import { ConfigServiceProvider } from '../../core/services/config-service/config-service';
import { FormField } from '../../../submodules/sellions_forms/projects/forms/src/lib/interfaces/form-field.interface';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StorageServiceProvider } from '../../core/services/storage-service/storage-service';

@Injectable()
export class TaskService {
  private readonly storageKey = 'taskFormDefinition';

  constructor(private configService: ConfigServiceProvider, private http: HttpClient, private storageService: StorageServiceProvider) {}

  load() {
    this.http.get<FormField[]>(this.configService.getEngineUrl('taskFormDefinition')).subscribe(
      (response) => this.storageService.setObject(this.storageKey, response),
      (error) => console.error(error),
    );
  }

  getFormDefinition(): Promise<FormField[]> {
    return this.storageService.getObject(this.storageKey);
  }

  saveTask(task: SaveTask): Observable<any> {
    return this.http.post(this.configService.getEngineUrl('createTask'), task);
  }
}

export interface SaveTask {
  taskType: {
    id: number;
    dictionaryDefinitionId: number;
  };
  representative?: number;
  description: string;
  client: string;
  topic: string;
  priority: {
    id: number;
    dictionaryDefinitionId: number;
  };
}



// WEBPACK FOOTER //
// ./src/modules/tasks/services/task.service.ts